module.exports = __webpack_public_path__ + "OpenSans-BoldItalic.7be88e73fea7b64568a4.woff";


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/node_modules/npm-font-open-sans/fonts/BoldItalic/OpenSans-BoldItalic.woff
// module id = ../../../../npm-font-open-sans/fonts/BoldItalic/OpenSans-BoldItalic.woff
// module chunks = styles